import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
  min-width: 186px;
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black6};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow-x: auto;
  gap: 20px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    align-items: center;
    flex-direction: row;
  }

  & > :last-child {
    font-weight: 300;
    font-size: 12px;
  }
`;

export const BadgeWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-shrink: 0;
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow-x: auto;
`;

export const ItemWrapper = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 300;
  font-size: 12px;
`;

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.black9};
  text-decoration: underline !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
